import {$authHost, $host} from "./index"

export const getUsers = async () => {
  const {data} = await $authHost.get('api/user/') //admin-gated; $authHost adds the Bearer token
  return data
}

export const registration = async (userEmail, password, lang) => {
  const email = userEmail.toLowerCase()
  const role = (process.env.REACT_APP_ADMIN_EMAIL === email) ? 'admin' : 'user';
  const {data} = await $authHost.post('api/auth/registration', {email, password, role, lang})
  return data
}

export const login = async (userEmail, password) => {
  const email = userEmail.toLowerCase()
  const {data} = await $authHost.post('api/auth/login', {email, password})
  return data
}

export const sendActivationLink = async (userEmail, userLang = 'en') => {
  const email = userEmail.toLowerCase()
  const {data} = await $authHost.get('api/auth/send-activation/' + email + '?lang=' + userLang)
  return data
}

export const checkAuth = async () => {
  const {data} = await $host.get('api/auth/refresh')
  return data
}

export const updateInfo = async (userInfo) => {
  const {data} = await $authHost.post('api/auth/update', userInfo)
  return data
}

export const getIP = async () => {
  try {
    const res = await fetch("https://api.ipify.org/?format=json")
    const client = await res.json() || {}
    return client.ip
  } catch (e) {
    return ''
  }
}
